module.exports = __webpack_public_path__ + "img/status.e37eb21e.webp";